export default __webpack_public_path__ + "static/media/jenkins.13ad34ef.svg";